(function () {
  'use strict';

  var SEARCH_FORM_SELECTOR = 'form[action*="/search"], .yl-search-form';
  var TEMP_QUERY_SELECTOR = 'input[data-tomokagu-sku-query="true"]';

  function normalizeQuery(value) {
    return String(value || '').trim().replace(/[\uFF0A*]+$/g, '');
  }

  function containsCjkOrKana(value) {
    return /[\u3040-\u30ff\u3400-\u9fff]/.test(value);
  }

  function isSkuQuery(value) {
    var query = normalizeQuery(value);

    if (!query || containsCjkOrKana(query)) return false;

    return /^(?=.*[A-Za-z])(?=.*\d)(?=.*-)[A-Za-z0-9]+(?:-[A-Za-z0-9]+)+$/.test(query);
  }

  function ensureHiddenInput(form, name, value, temporary) {
    var input = temporary
      ? form.querySelector(TEMP_QUERY_SELECTOR)
      : form.querySelector('input[name="' + name + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;

      if (temporary) {
        input.setAttribute('data-tomokagu-sku-query', 'true');
      }

      form.appendChild(input);
    }

    input.value = value;
  }

  function removeTemporaryQuery(form) {
    var input = form.querySelector(TEMP_QUERY_SELECTOR);

    if (input && input.parentNode) {
      input.parentNode.removeChild(input);
    }
  }

  function restoreInputName(input, originalName) {
    if (originalName) {
      input.setAttribute('name', originalName);
    }

    if (input.form) {
      removeTemporaryQuery(input.form);
    }
  }

  function replaceVisibleText(from, to) {
    var walker;
    var node;
    var nodes = [];
    var filter = {
      acceptNode: function (textNode) {
        var parent = textNode.parentNode;
        var tagName = parent && parent.nodeName;

        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(tagName)) {
          return NodeFilter.FILTER_REJECT;
        }

        return textNode.nodeValue.indexOf(from) > -1
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    };

    if (!from || from === to || !document.body || !window.NodeFilter) return;

    document.title = document.title.split(from).join(to);
    walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, filter);

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    nodes.forEach(function (textNode) {
      textNode.nodeValue = textNode.nodeValue.split(from).join(to);
    });
  }

  function hideDisplayedSkuStar() {
    var url = new URL(window.location.href);
    var rawQuery = url.searchParams.get('q');
    var cleanQuery = rawQuery ? normalizeQuery(rawQuery) : '';

    document.querySelectorAll('input[name="q"], input[type="search"]').forEach(function (input) {
      var cleanValue = normalizeQuery(input.value);

      if (input.value !== cleanValue && isSkuQuery(cleanValue)) {
        input.value = cleanValue;
      }
    });

    if (!rawQuery || rawQuery === cleanQuery || !isSkuQuery(cleanQuery)) return;

    replaceVisibleText(rawQuery, cleanQuery);
    url.searchParams.set('q', cleanQuery);
    window.history.replaceState(window.history.state, document.title, url.toString());
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;

      if (!form || !form.matches || !form.matches(SEARCH_FORM_SELECTOR)) return;

      var input = form.querySelector('input[name="q"], input[type="search"]');
      if (!input) return;

      var cleanValue = normalizeQuery(input.value);
      var originalName = input.getAttribute('name');
      var shouldUseSkuQuery = isSkuQuery(cleanValue);

      input.value = cleanValue;

      ensureHiddenInput(form, 'options[prefix]', 'last');

      if (!shouldUseSkuQuery) {
        removeTemporaryQuery(form);
        return;
      }

      if (originalName === 'q') {
        input.removeAttribute('name');
      }

      ensureHiddenInput(form, 'q', cleanValue + '*', true);
      window.setTimeout(function () {
        restoreInputName(input, originalName);
      }, 0);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideDisplayedSkuStar);
  } else {
    hideDisplayedSkuStar();
  }
})();